import * as React from "react";
import PropTypes from "prop-types";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import AppBarComponent from "./header";
import DrawerComponent from "./sidebar";

import { Outlet, useLocation, useRouteError } from "react-router-dom";
import ErrorPage from "@/components/Error/ErrorPage";
// import { AppBar, Toolbar, Typography } from "@mui/menvaterial";
import menuItems from "./menulist";
// import Index from "@/pages/people";
import Index from "@/components/tab/ViewTab";
import Loader from "../loader";
import ChatBotNew from "../chatbot/ChatBotNew";
// import WorkLocation from "../../pages/master/workLocation/index"
// import RoleOfIntake from "../../pages/master/roleOfIntake/index"
// import Department from "../../pages/master/department/index"
// import Designation from "../../pages/master/designation/index"
// import Document from "../../pages/master/document/index"
// import Employee from "../../pages/master/employee/index"
// import EmployeeType from "../../pages/master/employeeType/index"

const drawerWidth = 80;

const ResponsiveDrawer = (props) => {
  const error = useRouteError();
  const location = useLocation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [load, setLoad] = React.useState(false);
 

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerTransitionEnd = () => {
    if (isClosing) {
      setIsClosing(false);
    }
  };
  const container =
    window !== undefined ? () => window().document.body : undefined;

  const drawer = (
    <DrawerComponent
      mobileOpen={mobileOpen}
      handleDrawerClose={handleDrawerClose}
      handleDrawerTransitionEnd={handleDrawerTransitionEnd}
      container={container}
    />
  );

  const url = location.pathname;

  const findMatchedSubmenu = (items, currentPath) => {
    for (const item of items) {
      // Check if the main path matches and has a submenu
      if (item.path === currentPath && item.submenu) {
        // setTabText(item.text);
        return { submenu: item.submenu, text: item.text };
        // return item.submenu;
      }

      // Check if the submenu contains the currentPath
      if (item.submenu) {
        const matchedSubItem = item.submenu.some(
          (subItem) => subItem.path === currentPath
        );
        // console.log(matchedSubItem);
        if (matchedSubItem) {
          // setTabText(item.text);
          return { submenu: item.submenu, text: item.text };
          // return item.submenu;
        }
      }
    }
    return { submenu: [], text: "" }; // Return empty array if no match is found
    // return []; // Return empty array if no match is found
  };

  const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));

  const menuss = localStorageData?.userDetails?.permission;

  const matchedItem = findMatchedSubmenu(menuss, url);

  const handleLoader = (state) => setLoad(state);

  return (
    <Box sx={{ display: "flex", position: "relative" }}>
      <CssBaseline />
      <Box>
        <AppBarComponent
          handleDrawerToggle={handleDrawerToggle}
          loaderval={handleLoader}
        />
      </Box>
      {window ? (
        <DrawerComponent
          mobileOpen={mobileOpen}
          handleDrawerClose={handleDrawerClose}
          handleDrawerTransitionEnd={handleDrawerTransitionEnd}
          container={container}
        />
      ) : (
        <DrawerComponent
          mobileOpen={mobileOpen}
          handleDrawerClose={handleDrawerClose}
          handleDrawerTransitionEnd={handleDrawerTransitionEnd}
          container={container}
        />
      )}

      {load ? (
        <Loader />
      ) : (
        <Box
          component="main"
          // position=""
          mt={0}
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            marginLeft: { sm: `${drawerWidth}px` },
          }}
        >
          {/* <Toolbar /> */}

          {/* <Typography variant="h6">Additional Content</Typography> */}

          {matchedItem.submenu?.length > 0 && (
            <Box
              sx={{
                position: "sticky",
                top: 62,
                zIndex: 2,
                width: "100%",
                // width: { sm: `calc(100% - (${drawerWidth}px + 44px))` },
                marginRight: { xs: 0, sm: "24px" },
                // borderRadius: 30,
                // height: "auto",
                // backgroundColor: "#fdf9f6",
                // color: "black",
                // zIndex: 2,
                paddingRight: 0,
                boxShadow: "none",
              }}
            >
              <Index tabs={matchedItem.submenu} tabtitle={matchedItem.text} />
            </Box>
          )}

          <Box
            sx={{
              position: "relative",
              top: matchedItem?.submenu?.length > 0 ? 62 : 46,
            }}
          >

            {error ? <ErrorPage /> : <Outlet />}
          </Box>
          <Box sx={{ position: "fixed", bottom: 0, right: 0, zIndex: 1300 }}>
            <ChatBotNew />
          </Box>
        </Box>
      )}
    </Box>
  );
};

ResponsiveDrawer.propTypes = {
  window: PropTypes.func,
};

export default ResponsiveDrawer;
